import { getDictionaryById } from 'common/components/segment/helpers';

import { INITIALIZE_VALUES } from '../actionTypes';
import { actions } from '../reducer';
import * as selectors from '../selectors';

export default (segmentId) => (dispatch, getState) => {
    const state = getState();
    const segments = selectors.getSegmentsData(state);
    const segmentsDictionary = getDictionaryById(segments);
    if (!segmentsDictionary[segmentId]) return;
    dispatch(actions[INITIALIZE_VALUES](segmentsDictionary[segmentId]));
};
